import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { AttachmentItemComponent } from './components/attachment-item/attachment-item.component';
import { AttachmentModalComponent } from './components/attachment-modal/attachment-modal.component';
import { SINGLECALLCARD_ATTACHMENTS } from './schema/constants';
import { AddAttachmentCardButtonControllerService } from './services/add-attachment-card-button-controller/add-attachment-card-button-controller.service';
import { AttachmentsCardButtonControllerService } from './services/attachments-card-button-controller/attachments-card-button-controller.service';
import { CardButtonsService } from './services/executables/card-buttons/card-buttons.service';

const views = [];

const executables = [CardButtonsService];

const providers = [AddAttachmentCardButtonControllerService, AttachmentsCardButtonControllerService, ...executables];

const components = [AttachmentModalComponent, AttachmentItemComponent, ...views];

const directives = [];

@Addin({
  name: SINGLECALLCARD_ATTACHMENTS
})
@NgModule({
  declarations: [...components, ...directives],
  providers,
  imports: [CommonModule, IonicModule, SagaPipeModule]
})
export class SingleCallcardAttachmentsModule extends AddinModule {
  public constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
